import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TypeSkeletonUtil } from "../TypeSkeletonUtil";
export const TypeSkeleton = ({ lineCount = 1, shortenLastLine = false, leading = "normal", }) => {
    return (_jsxs("div", { "data-eco-component": "type-skeleton", className: "animate-pulse", children: [_jsx(TypeSkeletonUtil, { lineCount: lineCount, shortenLastLine: shortenLastLine, leading: leading }), _jsx("span", { className: "sr-only", children: "Loading" })] }));
};
export default TypeSkeleton;
